import React, { useEffect, useRef, useState } from "react";
import {
  arrow_icon,
  delete_icon,
  dummyimage,
  toggle_off,
  toggle_on,
} from "../../assets/img";
import { useLocation, useNavigate } from "react-router-dom";
import Topbar from "../../components/Topbar/Topbar";
import { get, post } from "../../Services/ApiHandler"; // assume post/put exist
import { URLS } from "../../Services/Constant";
import { toast } from "react-toastify";
// import { postMultipart } from "../../Services/HttpClient";

const ServicesEdit = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const inputRef = useRef(null);

  const [formData, setFormData] = useState({
    displayName: "",
    realName: "",
    payment: "full",
    policies: [],
    cancellation: false,
    percentage: 0,
    priority: 0,
    image: null,
  });
  const [policy, setPolicy] = useState("");
  const [errors, setErrors] = useState({});
  const [deleteId, setDeleteId] = useState();
  const [popup, setPopup] = useState(false);

  const type = location?.state?.type; // add | edit | view
  const serviceId = location?.state?.id;

  // fetch details
  const fetchDetails = async () => {
    try {
      const res = await get(`${URLS.SERVICESLIST}${serviceId}/`);
      if (res?.data) {
        setFormData({
          displayName: res.data.display_name || "",
          realName: res.data.name || "",
          payment: res.data.payment_type || "full",
          policies: res.data.cancellation_policy || [],
          cancellation: res.data.is_cancellation || false,
          percentage: res.data.cancellation_percentage || "",
          priority: res.data.cancellation_days || "",
          image: res.data.image || dummyimage,
        });
      }
    } catch (err) {
      console.log("err", err);
    }
  };

  useEffect(() => {
    if (type === "view" || type === "edit") {
      fetchDetails();
    }
  }, [type]);

  // handle validations
  const validateFields = () => {
    let valid = true;
    let tempErrors = {};
    if (!formData.displayName.trim()) {
      tempErrors.displayName = "Display Name is required";
      valid = false;
    }
    if (!formData.realName.trim()) {
      tempErrors.realName = "Real Name is required";
      valid = false;
    }
    if (!formData.payment) {
      tempErrors.payment = "Select a payment type";
      valid = false;
    }
    if (formData.policies.length === 0) {
      tempErrors.policies = "At least one cancellation policy is required";
      valid = false;
    }
    if (formData.cancellation) {
      if (!formData.percentage) {
        tempErrors.percentage = "Cancellation Percentage is required";
        valid = false;
      }
      if (!formData.priority) {
        tempErrors.priority = "Priority Days is required";
        valid = false;
      }
    }
    setErrors(tempErrors);
    return valid;
  };

  // handle submit
  const handleSubmit = async () => {
    if (!validateFields()) return;

    const body = new FormData();
    body.append("display_name", formData.displayName);
    body.append("name", formData.realName);
    body.append("payment_type", formData.payment);
    body.append("cancellation_policy", JSON.stringify(formData.policies));
    body.append("is_cancellation", formData.cancellation ? "true" : "false");
    if (formData.cancellation) {
      body.append("cancellation_percentage", formData.percentage);
      body.append("cancellation_days", formData.priority);
    } else {
      body.append("cancellation_percentage", 0);
      body.append("cancellation_days", 0);
    }

    console.log("body", body);

    if (formData.image && typeof formData.image !== "string") {
      body.append("image", formData.image);
      console.log("formDataSSimage", formData.image);
    }

    try {
      const res = await post(`${URLS.SERVICESLIST}${serviceId}/edit/`, body, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (res.status === "success") {
        toast.success(res.message || "Service updated successfully");
      }
      navigate("/services");
    } catch (err) {
      console.log("something went ", err);

      toast.error(err?.response?.data?.message || "Something went wrong!");
      console.log("submit err", err);
    }
  };

  // handle inputs
  const handleChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    handleChange("image", file);
  };

  const addPolicy = () => {
    if (policy.trim() !== "") {
      handleChange("policies", [...formData.policies, policy.trim()]);
      setPolicy("");
    }
  };

  const handleDeletePolicy = () => {
    setPopup(false);
    handleChange(
      "policies",
      formData.policies.filter((p) => p !== deleteId),
    );
    toast.success("Deleted successfully");
  };

  return (
    <div>
      <Topbar
        header={
          type === "view"
            ? "Master View"
            : type === "edit"
              ? "Master Edit"
              : "Add Service"
        }
        subHead="Services"
      />

      <div className="d-flex flex-wrap gap-5">
        {/* Display Name */}
        <div className="col-md-5">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
            Display Name <span className="red">*</span>
          </p>
          <input
            className="input-box"
            readOnly={type === "view"}
            value={formData.displayName}
            onChange={(e) => handleChange("displayName", e.target.value)}
          />
          {errors.displayName && <p className="err">{errors.displayName}</p>}
        </div>

        {/* Real Name */}
        <div className="col-md-5">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
            Real Name <span className="red">*</span>
          </p>
          <input
            className="input-box"
            disabled={type === "view" || type === "edit"}
            value={formData.realName}
            onChange={(e) => handleChange("realName", e.target.value)}
          />
          {errors.realName && <p className="err">{errors.realName}</p>}
        </div>

        {/* Image */}
        <div className="col-md-5">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
            Image
          </p>
          <div className="mb-2 w-100 d-flex ac-jb">
            <div
              onClick={() => inputRef.current.click()}
              className="position-relative w-100"
            >
              <img
                alt="preview"
                style={{ width: "80px", height: "80px", borderRadius: "10px" }}
                src={
                  formData.image
                    ? typeof formData.image === "string"
                      ? formData.image
                      : URL.createObjectURL(formData.image)
                    : dummyimage
                }
              />
              <input
                type="file"
                hidden
                ref={inputRef}
                disabled={type === "view"}
                accept="image/*"
                onChange={handleImageChange}
              />
              {type != "view" && (
                <h4 style={{ fontSize: 12 }} className="err mt-2">
                  Max Upload Size : 5MB and Banner Size 1200x700*
                </h4>
              )}
            </div>
          </div>
        </div>

        {/* Payment Type */}
        <div className="col-md-5">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
            Payment Type
          </p>
          <div className="d-flex ac-js gap-1">
            {[1, 2, 3, 4].map((val) => (
              <label key={val} className="d-flex ac gap-1">
                <input
                  type="radio"
                  disabled={type === "view"}
                  name="payment"
                  value={val}
                  checked={formData.payment === val}
                  onChange={(e) =>
                    handleChange("payment", Number(e.target.value))
                  }
                />
                <span className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1 ">
                  {val === 1
                    ? "Full"
                    : val === 2
                      ? "Partial"
                      : val === 4
                        ? "Vow Commission"
                        : "Pay At Hotel"}
                </span>
              </label>
            ))}
          </div>

          {errors.payment && <p className="err">{errors.payment}</p>}
        </div>

        {/* Cancellation Policy */}
        <div className="col-md-7">
          <div className="d-flex ac-jb mb-3">
            <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
              Cancellation Policy
            </p>
            {type !== "view" && (
              <button onClick={addPolicy} className="submit-btn">
                Add
              </button>
            )}
          </div>
          {type !== "view" && (
            <textarea
              value={policy}
              onChange={(e) => {
                const sanitizedValue = e.target.value.replace(/,/g, "");
                setPolicy(sanitizedValue);
              }}
              placeholder="Cancellation Policy"
              className="input-border"
            />
          )}
          {errors.policies && <p className="err">{errors.policies}</p>}
          <ul>
            {formData.policies.map((p, i) => (
              <li key={i} className="d-flex as-js gap-3 my-3">
                <img src={arrow_icon} className="back-arrow" alt="" />
                <p className="f2 fs-sm-10 fs-md-14 fs-lg-15 fs-xl-16 fs-xxl-18 col-md-10">
                  {p}
                </p>
                {type !== "view" && (
                  <img
                    src={delete_icon}
                    alt="delete"
                    className="edit-btn"
                    onClick={() => {
                      setPopup(true);
                      setDeleteId(p);
                    }}
                    // onClick={() => {handleDeletePolicy(p)}}/
                  />
                )}
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Cancellation toggle */}
      <div className="d-flex ac-jb mb-3 mt-4 col-md-3">
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
          Cancellation
        </p>
        <img
          onClick={() =>
            type !== "view" &&
            handleChange("cancellation", !formData.cancellation)
          }
          src={formData.cancellation ? toggle_on : toggle_off}
          className="roles-icon pointer"
          alt=""
        />
      </div>

      {/* Cancellation details */}
      {formData.cancellation && (
        <div className="toggle-drop d-flex ac-jb col-md-7 open">
          <div>
            <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
              Cancellation Percentage
            </p>
            <input
              type="number"
              min="0"
              max="100"
              value={formData.percentage}
              disabled={type === "view"}
              onChange={(e) => {
                const val =
                  e.target.value === ""
                    ? ""
                    : Math.max(0, Math.min(100, Number(e.target.value)));
                handleChange("percentage", val);
              }}
              className="input-border"
            />

            {errors.percentage && <p className="err">{errors.percentage}</p>}
          </div>
          <div>
            <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
              Priority Days
            </p>
            <input
              type="number"
              value={formData.priority}
              disabled={type === "view"}
              onChange={(e) => handleChange("priority", e.target.value)}
              className="input-border"
            />
            {errors.priority && <p className="err">{errors.priority}</p>}
          </div>
        </div>
      )}

      {/* Submit button */}
      {type !== "view" && (
        <div className="d-flex ac-js mt-5">
          <button onClick={handleSubmit} className="submit-btn">
            Submit
          </button>
        </div>
      )}

      {popup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p className="f3 ms-2  ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-4">
              Are you sure, want to Delete?
            </p>
            <div className="d-flex ac-jb px-2 mt-5">
              <button onClick={handleDeletePolicy} className="add-btn w-40">
                Yes
              </button>
              <button
                onClick={() => {
                  setPopup(false);
                }}
                className="back-btn f2 w-40"
              >
                {/* {loading ? "Loading..." : "Confirm"} */}No
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ServicesEdit;
